import {Injectable} from '@angular/core';
import {ApiService} from "./api.service";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {SignatureConfig} from "../../modules/dashboard/home/home-enterprise/document/sign-flow-document/signature-config.model";
import {EnvService} from "./env.service";

const routes = {
  genImage: `/image/generate-image`
};

@Injectable({
  providedIn: 'root'
})
export class ImageGenerateService {

  constructor(private apiService: ApiService,
              private http: HttpClient,
              private translateService: TranslateService,
              private env: EnvService) {
  }

  genImage(signConfig: SignatureConfig, imageSize: { width: string, height: string }) {
    // return this.http.post('http://localhost:8080/api/image', { responseType: 'blob' });
    let width = imageSize.width.replace("px", "");
    let height = imageSize.height.replace("px", "");

    const payload: GenImagePayload = {
      imagePosition: signConfig.signaturePosition.value,
      contentPosition: signConfig.contentPosition.value,
      ratio: signConfig.signatureRatio.value.replace(":", ""),
      checked: false,
      width: Number(width),
      height: Number(height),
      fontName: signConfig.fontFamily.value,
      fontStyle: "",
      fontWeight: "",
      textColor: "",
      uid: "",
      textField: [{
        key: "",
        lineNumber: 1,
        content: ""
      }]
    };
    const textField: GenImageTextField[] = [];

    if (signConfig) {
      if (signConfig.enterpriseName.enabled) {
        textField.push({
          key: `${this.translateService.instant(signConfig.enterpriseName.label)}: `,
          lineNumber: 1,
          content: signConfig.enterpriseName.value
        })
      }

      if (signConfig.signingTime.enabled) {
        textField.push({
          key: `${this.translateService.instant(signConfig.signingTime.label)}: `,
          lineNumber: 3,
          content: signConfig.signingTime.value
        })
      }
      if (signConfig.customSymbol && signConfig.customSymbol.enabled) {
        textField.push({
          key: ``,
          lineNumber: 3,
          content: signConfig.customSymbol.value
        })
      }

      if (signConfig.phoneNumber && signConfig.phoneNumber.enabled) {
        textField.push({
          key: `${this.translateService.instant(signConfig.phoneNumber.label)}: `,
          lineNumber: 3,
          content: signConfig.phoneNumber.value
        })
      }
      if (signConfig.position.enabled) {
        textField.push({
          key: `${this.translateService.instant(signConfig.position.label)}: `,
          lineNumber: 3,
          content: signConfig.position.value
        })
      }

      if (signConfig.address.enabled) {
        textField.push({
          key: `${this.translateService.instant(signConfig.address.label)}: `,
          lineNumber: 3,
          content: signConfig.address.value
        })
      }
      
      if (signConfig.organizationName && signConfig.organizationName.enabled) {
        textField.push({
          key: `${this.translateService.instant(signConfig.organizationName.label)}: `,
          lineNumber: 3,
          content: signConfig.organizationName.value
        })
      }

      // add field email to payload request
      if (signConfig.email.enabled) {
        textField.push({
          key: `${this.translateService.instant(signConfig.email.label)}: `,
          lineNumber: 3,
          content: signConfig.email.value
        })
      }
      if (signConfig.confirmBy.enabled) {
        textField.push({
          key: `${this.translateService.instant(signConfig.confirmBy.label)}: `,
          lineNumber: 3,
          content: signConfig.confirmBy.value
        })
      }


      payload.fontStyle = signConfig.fontStyle.value;
      payload.fontWeight = signConfig.fontWeight.value;

      if (signConfig.greenTick.enabled) {
        payload.checked = true;
      }

      if (signConfig.signatureImage.enabled && signConfig.signatureImageBase64.value) {
        payload.image = signConfig.signatureImageBase64.value;
      }
    }

    payload.textField = textField;
    let url = routes.genImage;
    let isCustomUrl = false;
    if (this.env.genimage_api_base_url) {
      url = `${this.env.genimage_api_base_url}${routes.genImage}`;
      isCustomUrl = true;
    }

    return this.apiService.postFileBase64(url, payload, {responseType: 'blob'}, isCustomUrl)
      .pipe(map(res => {
        return res
      }));
  }

}

export interface GenImageTextField {
  key: string,
  lineNumber: number
  content: string
}

export interface GenImagePayload {
  image?: string,
  imagePosition: string,
  contentPosition: string,
  ratio: string,
  checked: boolean
  width: number
  height: number
  fontName: string
  fontStyle: string,
  fontWeight: string,
  textColor: string,
  uid: string
  textField: GenImageTextField[]
}
